import { createSlice } from "@reduxjs/toolkit";
import { deleteMedia, getGalleryData, getGalleryDataById } from "./thunk";

const initialState = {
  galleryData: [],
  galleryLoading: false,
  deleteLoading: false,
  error: null,
};

const gallerySlice = createSlice({
  name: "gallery",
  initialState,
  reducers: {
    resetGalleryData: (state) => {
      state.galleryLoading = false;
      state.galleryData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ------------------------------------------------------Get Media
      .addCase(getGalleryData.pending, (state) => {
        state.galleryLoading = true;
        state.error = null;
      })
      .addCase(getGalleryData.fulfilled, (state, action) => {
        state.galleryLoading = false;
        state.galleryData = action.payload;
      })
      .addCase(getGalleryData.rejected, (state, action) => {
        state.galleryLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Get Media by id
      .addCase(getGalleryDataById.pending, (state) => {
        state.galleryLoading = true;
        state.error = null;
      })
      .addCase(getGalleryDataById.fulfilled, (state, action) => {
        state.galleryLoading = false;
        state.galleryData = action.payload;
      })
      .addCase(getGalleryDataById.rejected, (state, action) => {
        state.galleryLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Delete Media
      .addCase(deleteMedia.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
      })
      .addCase(deleteMedia.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.galleryData = action.payload;
      })
      .addCase(deleteMedia.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetGalleryData } = gallerySlice.actions;
export default gallerySlice.reducer;
